import cx from 'classnames';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import { SchoolsList } from '../../../../peekapak-types/ReportDataExchangeTypes';
import styles from './SchoolSelector.module.scss';

interface Props {
  isDistrictAdmin: boolean;
  schoolsList: SchoolsList;
  onSelectSchool: (arg0: string | null) => void;
  initialValue: string;
  currentlySelectedSchool: string;
  disableChangeLocation: boolean;
}
const SchoolSelector = ({
  isDistrictAdmin,
  schoolsList,
  onSelectSchool,
  initialValue,
  currentlySelectedSchool,
  disableChangeLocation,
}: Props) => {
  const { list, district } = schoolsList;

  if (list.length === 0) {
    return (
      <div className={styles.schoolSelectorContainer}>
        <div className={cx(styles.schoolSelector, styles.inlineSelector, styles.selectorErrorMessage)}>
          There are no schools listed for your current district: {district}
        </div>
      </div>
    );
  }

  const schoolName = (() => {
    // If no school is selected yet (during async determination), show loading state
    if (!initialValue) {
      return 'Loading...';
    }

    const foundSchool = list.filter((s) => s.id === initialValue);

    // For school admins: if their school ID is not found, show error
    // For district/peekapak admins: they use CustomDropdown, not this text
    return foundSchool[0]?.name || 'School not found';
  })();

  return (
    <div className={styles.schoolSelectorContainer}>
      {isDistrictAdmin ? (
        <CustomDropdown
          list={list}
          onSelectSubject={onSelectSchool}
          initialValue={initialValue}
          currentlySelectedItem={currentlySelectedSchool}
          disableChangeLocation={disableChangeLocation}
          icon={'icon-park-outline:school'}
        />
      ) : (
        <>
          <span className={styles.schoolName}>{schoolName}</span>
        </>
      )}
    </div>
  );
};

export default SchoolSelector;
